export default __webpack_public_path__ + "static/media/love.4f331286.png";